import { ActivatedRoute } from "@angular/router";
import { Job } from "./job.model";
import { Injectable } from "@angular/core";

import { Subject } from "rxjs";
import { AccountantService } from "../accountant.service";
import { JobsService } from "./jobs.service";
import { DashboardStore } from "src/app/dashboard/dashboard.store";

@Injectable({ providedIn: "root" })
export class JobsStore {
  jobs = {
    current: [],
    future: [],
    completed: [],
  };

  company: any = { accountants: [] };

  activeTab = "current";

  changeSelectedJob = new Subject<any>();
  notifyJobDeleted = new Subject<any>();
  reloadJobs$ = new Subject<any>();

  constructor(
    private route: ActivatedRoute,
    private accountantService: AccountantService,
    private jobsService: JobsService,
    private dashboardStore: DashboardStore,
  ) {
    // this.dashboardStore.currentCompanyChanged$.subscribe((company) => {
    //   this.company = company;
    // });

    this.accountantService.get_company_info().then((info) => {
      this.company = info;
    });

    // Using this to keep up with individual changes to the jobs in store
    // this.jobsService.jobContentChanged.subscribe((job: Job) => {
    //   for (let x = 0; x < this.jobs[this.activeTab].length; x++) {
    //     if (this.jobs[this.activeTab][x].uuid == job.uuid) {
    //       job["selected"] = true;
    //       this.jobs[this.activeTab][x] = job;
    //     }
    //   }
    // });
  }

  removeJob(job: Job, shouldLoadNext = true) {
    Object.keys(this.jobs).forEach((key) => {
      this.jobs[key] = this.jobs[key].filter((j) => {
        return j.uuid !== job.uuid;
      });
    });

    if (this.jobs[this.activeTab].length > 0 && shouldLoadNext) {
      this.changeSelectedJob.next(this.jobs[this.activeTab][0]);
    }
    this.notifyJobDeleted.next(job.uuid);
  }

  updateReadStatusBadgeOnStore() {}

  resetJobs() {
    this.jobs = {
      current: [],
      future: [],
      completed: [],
    };
  }
}
